import { Card, ListGroup } from "react-bootstrap";
import "./Menu.css";

const pizzas = [
  {
    name: "Margherita",
    description: "Tomate, Mozzarella",
  },
  {
    name: "Chorizo",
    description: "Tomate, Mozzarella, Chorizo",
  },
  {
    name: "Funghi",
    description: "Tomate, Mozzarella, Champignons",
  },
  {
    name: "Quattro Formaggi",
    description: "Tomate, Mozzarella, Gorgonzola, Parmesan, Brie",
  },
  {
    name: "Vegetaria",
    description: "Tomate, Mozzarella, Paprika, Zwiebeln, Oliven, Champignons",
  },
  {
    name: "Chorizo e Gorgonzola",
    description: "Tomate, Mozzarella, Chorizo, Gorgonzola",
  },
];

export function PizzaMenu() {
  return (
    <Card className="mb-4 menu-card">
      <Card.Header as="h5">Pizza</Card.Header>
      <ListGroup variant="flush">
        {pizzas.map((pizza) => (
          <ListGroup.Item key={pizza.name} className="menu-list-item">
            <strong>{pizza.name}</strong>
            <p className="mb-0 text-muted">{pizza.description}</p>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card>
  );
}
